import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ZWfCatalogActionCreate } from "src/business/catalog/ZCatalog";
import { loadWorkflow } from "src/business/workflow/apiWorkflow";
import { getWorkflowDisplayName } from "src/business/workflow/getWorkflowDisplayName";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZId } from "src/types";

import { CreateBtnLinkStd } from "./CreateBtnLinkStd";

const makeStore = (workflowId: string) =>
  makeAutoObservable({
    workflowTitle: "",
    loading: !!workflowId,
    setWorkflowTitle(title: string) {
      this.workflowTitle = title;
    },
    setLoading(flag: boolean) {
      this.loading = flag;
    },
    async loadWorkflowTitle() {
      if (!workflowId) {
        this.setLoading(false);
        return;
      }

      this.setLoading(true);
      try {
        const workflow = await loadWorkflow(workflowId);
        this.setWorkflowTitle(getWorkflowDisplayName(workflow));
      } finally {
        this.setLoading(false);
      }
    },
  });

type PropsWorkflowCreateActionRenderer = ZWfCatalogActionCreate & {
  catalogId: ZId;
};

export const WorkflowCreateActionRenderer: React.FC<PropsWorkflowCreateActionRenderer> =
  observer(({ catalogId, disabled, workflowId }) => {
    const store = React.useMemo(() => makeStore(workflowId), [workflowId]);
    React.useEffect(() => {
      store.loadWorkflowTitle();
    }, [store]);

    const isDisabled = disabled || !workflowId;
    const baseText = isDisabled
      ? "Недоступно создание записи: нет доступа на работу в РП"
      : "Запись будет создана через рабочий поток:";

    return (
      <CreateBtnLinkStd
        text="Запись (РП)"
        disabled={isDisabled}
        tooltip={`${baseText} «${store.loading ? "..." : store.workflowTitle}»`}
        url={makeUrl(PageUrl.newRecordWf, { id: catalogId, workflowId })}
      />
    );
  });
